import {type Ref as PanelRef} from '../../state/views/panel/types';
import {type LayedOutPanelWithRef} from '../../util/panelTypes';
import {type InlineCommentDetail} from '../Slate/plugins/inline-comments-common';

export type CommentableItem = LayedOutPanelWithRef;
export type CommentableRef = PanelRef;

export type createCommentCallbackFnType = (
  details?: InlineCommentDetail[],
  threadID?: string,
  commentID?: string
) => void;

export const USER_MENTION_REGEXP = /@\[(.*?]\(.*?)\)/g;
export const PANEL_MENTION_REGEXP = /&\[(.*?]\(.*?)\)/g;
export const INLINE_MENTION_REGEXP = /\|\[(.*?]\(.*?)\)/g;

export interface MentionableUser {
  id: string;
  username: string;
  name: string;
  photoUrl: string;
}
